import __request__ from "routing/request";
export function updateEmailNotificationDefaults(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.customization/email_notification_defaults", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getEmailNotificationDefaults(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.customization/email_notification_defaults", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
